import { render } from "./SelectPerForH5.vue?vue&type=template&id=1ccb3941&scoped=true"
import script from "./SelectPerForH5.vue?vue&type=script&lang=js"
export * from "./SelectPerForH5.vue?vue&type=script&lang=js"

import "./SelectPerForH5.vue?vue&type=style&index=0&id=1ccb3941&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccb3941"]])

export default __exports__